import React from 'react';
import { css } from '@emotion/core';
import { FadeLoader } from 'react-spinners';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SessionStorage from '../../../api/session-storage';
import Requests from '../../../api/requests';
import ButtonPrimary from '../../components/buttons/button-primary';
import ButtonSecondary from '../../components/buttons/button-secondary';

import Modal from '../../components/modal/modal';
import PopupOneButton from '../../components/popup/popup-one-button';
import PopupTwoButtons from '../../components/popup/popup-two-buttons';
import { selectKey } from '../../../utilities/helper';
import {
  saveLoggedUser,
  saveUser,
  receivedAdmin,
  updateCofirmationInd,
} from '../../../store/actions/user-actions';
import './user-confirmation.scss';
import _ from 'lodash';

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      saveLoggedUser,
      saveUser,
      receivedAdmin,
      updateCofirmationInd,
    },
    dispatch,
  );
};

class UserConfirmation extends React.Component {
  constructor() {
    super();
    this.state = {
      modalIsOpen: false,
      browserModalIsOpen: false,
      browserIsLaunching: false,
      browserIsDownloading: false,
      name: '',
      testLocation: '',
      testTaking: '',
      photo: '',
      index: 0,
      modalIndex: 0,
      hasError: false,
      hasPSIError: false,
      hasPSIUrlError: false,
      hasInvalidParams: false,
      hasContent: false,
      loading: false,
      room_code: '',
      launch_tz: '',
      confirmation_ind: false,
      delivery_type: '',
      rp_session_id: null,
      rp_launch_url: '',
      rp_download_url: '',
      reconnect: false,
      auto_launch_ind: false,
    };
  }

  componentDidMount = async () => {
    if (this.props.userStore.hasUserLoggedOut || !this.props.userStore.admin) {
      this.setState({
        hasInvalidParams: true,
      });
      return;
    }
    window.addEventListener('keydown', this.keySelect);
    setTimeout(() => {
      this.setState({
        loading: true,
      });
    }, 400);
    const { saveLoggedUser } = this.props;
    saveLoggedUser(false);
    const admin = this.props.userStore.admin;
    const user = {
      admin_id: admin.admin_id,
      reg_id: admin.reg_id,
      token: admin.token,
    };
    this.setState({
      reg_id: admin.reg_id,
      admin_id: admin.admin_id,
      token: admin.token,
    });
    const { ok, json: body, status } = await Requests.getUser(user);
    if (ok) {
      if (status === 200) {
        let tempRpDownloadLink = '';
        if (body.delivery_type.toLowerCase() === 'remote') {
          if (navigator.appVersion.indexOf('Win') !== -1) {
            tempRpDownloadLink = body.rp_win_download;
          } else if (navigator.appVersion.indexOf('Mac') !== -1) {
            tempRpDownloadLink = body.rp_macos_download;
          } else {
            this.setState({ hasPSIError: true });
          }
        }

        this.setState({
          name: body.name,
          room_code: body.room_no,
          launch_tz: body.launch_tz,
          delivery_type: body.delivery_type,
          tlp_params: body.tlp_params,
          confirmation_ind: body.confirmation_ind,
          timing_modifier: parseInt(body.timing_modifier),
          auto_launch_ind: body.auto_launch_ind,
          rp_launch_url: body.rp_launch_url,
          rp_session_id: body.rp_session_id,
          rp_download_url: tempRpDownloadLink,
          testLocation: body.location,
          testTaking: body.taking,
          photo: body.photo,
          hasContent: true,
          loading: false,
          skipAddressChoice: body.skip_address_choice,
        });
      }
    } else {
      if (status === 400 || status === 403) {
        this.setState({ hasInvalidParams: true });
      }
      if (status === 500) {
        this.setState({ hasError: true });
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener('keydown', this.keySelect);
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps, this.state.props)) {
      const isUserLogged = this.props.userStore.isLogged;
      if (isUserLogged) {
        saveLoggedUser(false);
      }
    }
  }

  next = async () => {
    if (this.state.skipAddressChoice) {
      if (this.props.userStore.admin.ts_and_cs_ind) {
        this.props.history.push('/test-launcher');
      } else {
        this.props.history.push('/terms-and-conditions');
      }
    } else {
      this.props.history.push('/address-confirmation');
    }
  };

  continue = async () => {
    const { saveLoggedUser, saveUser } = this.props;
    const user = {
      name: this.state.name,
      testLocation: this.state.testLocation,
      testTaking: this.state.testTaking,
      photo: this.state.photo,
      delivery_type: this.state.delivery_type,
      tlp_params: this.state.tlp_params,
      launch_tz: this.state.launch_tz,
      auto_launch_ind: this.state.auto_launch_ind,
      timing_modifier: this.state.timing_modifier,
    };
    saveLoggedUser(true);
    saveUser(user);
    if (!this.state.confirmation_ind) {
      this.props.updateCofirmationInd({
        registration_id: this.state.reg_id,
        admin_id: this.state.admin_id,
        token: this.state.token,
        confirmation_ind: true,
      });
    }
    if (this.state.rp_session_id) {
      if (this.state.delivery_type.toLowerCase() === 'center') {
        this.next();
      } else {
        if (this.state.rp_launch_url) {
          this.setState(
            {
              reconnect: true,
            },
            () => {
              this.openBridgeModal();
            },
          );
        } else {
          this.setState({ hasPSIUrlError: true });
        }
      }
    } else {
      if (this.state.delivery_type.toLowerCase() === 'center') {
        this.next();
      } else {
        if (this.state.rp_launch_url) {
          this.openBridgeModal();
        } else {
          this.setState({ hasPSIUrlError: true });
        }
      }
    }
  };

  downloadBrowser = () => {
    if (this.state.rp_download_url) {
      this.setState({ browserIsDownloading: true });
      setTimeout(() => {
        this.setState({ browserIsDownloading: false });
      }, 3000);
      window.location = this.state.rp_download_url;
    } else {
      this.setState({ hasPSIUrlError: true });
    }
  };
  retryBrowser = () => {
    if (this.state.rp_launch_url) {
      window.location = this.state.rp_launch_url;
      this.setState({ browserIsLaunching: true });
      setTimeout(() => {
        this.setState({ browserIsLaunching: false });
      }, 3000);
    } else {
      this.setState({ hasPSIUrlError: true });
    }
  };
  openBridgeModal = () => {
    this.setState({ browserModalIsOpen: true });
    window.location = this.state.rp_launch_url;
    this.setState({ browserIsLaunching: true });
    setTimeout(() => {
      this.setState({ browserIsLaunching: false });
    }, 3000);
  };
  closeBridgeModal = () => {
    this.setState({ browserModalIsOpen: false, modalIndex: 0 });
  };

  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  closeModal = () => {
    this.setState({ modalIsOpen: false, modalIndex: 0 });
  };

  returnToLogin = () => {
    this.props.updateCofirmationInd({
      registration_id: this.state.reg_id,
      admin_id: this.state.admin_id,
      token: this.state.token,
      confirmation_ind: false,
    });
    this.closeModal();
    this.goToLogin();
  };

  closeInvalidModal = () => {
    this.setState({ hasInvalidParams: false, modalIndex: 0 });
    this.goToLogin();
  };

  refreshPage = () => {
    window.location.reload();
  };

  goToLogin = () => {
    const room = SessionStorage.getRoom();
    SessionStorage.clearStorage();
    if (room && room.toLowerCase().indexOf('remote') > -1) {
      this.props.history.push('/remote/login');
    } else {
      this.props.history.push('/');
    }
  };

  setIndex = index => {
    this.setState({ index: index });
  };

  setModalIndex = index => {
    this.setState({ modalIndex: index });
  };

  keySelect = event => {
    const ids = ['button-primary', 'button-secondary'];

    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowRight', 'ArrowLeft'];
    if (
      this.state.index <= 1 &&
      this.state.index >= 0 &&
      !document.getElementById('modal')
    ) {
      selectKey(
        event,
        this.state.index,
        ids,
        focusedElement,
        this.setIndex,
        arrows,
      );
    }
  };

  modalNavigation = (event, ids) => {
    const focusedElement = document.activeElement.id;
    const arrows = ['ArrowDown', 'ArrowUp'];
    if (this.state.modalIndex <= ids.length - 1 && this.state.modalIndex >= 0) {
      selectKey(
        event,
        this.state.modalIndex,
        ids,
        focusedElement,
        this.setModalIndex,
        arrows,
      );
    }
  };

  closeErrorModal = () => {
    this.setState({ hasError: false });
    this.goToLogin();
  };

  closePSIErrorModal = () => {
    this.setState({ hasPSIError: false });
    this.goToLogin();
  };

  closePSIUrlErrorModal = () => {
    this.setState({ hasPSIUrlError: false });
    this.goToLogin();
  };

  render() {
    const defaultImage =
      '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';
    const source = this.state.photo ? this.state.photo : defaultImage;
    const image = (
      <img src={`data:image;base64, ${source}`} alt="User Avatar" />
    );

    const override = css`
      display: block;
      margin: 0 auto;
    `;

    return !this.state.hasError &&
      !this.state.hasPSIError &&
      this.state.hasContent ? (
      <main className="user-confirmation">
        <div
          className="user-confirmation-heading"
          tabIndex={0}
          autoFocus={true}
        >
          <h1
            className="title"
            aria-label="Please confirm the following information"
          >
            Please confirm the following information:{' '}
          </h1>
        </div>
        <div className="user" tabIndex={0}>
          <div className="user-image">{image}</div>
          <div className="user-info">
            <p aria-label={`Name: ${this.state.name}`}>
              <span>Name:</span> {this.state.name}
            </p>
            <p
              className="location"
              aria-label={`Test Location: ${this.state.testLocation}`}
            >
              <span>Test Location:</span>
              <span>{this.state.testLocation}</span>
            </p>
            <p
              className="test-taking"
              aria-label={`Test${this.state.testTaking.indexOf(',') > -1 ? 's' : ''} Taking: ${this.state.testTaking}`}
            >
              <span>{`Test${this.state.testTaking.indexOf(',') > -1 ? 's' : ''} Taking:`}</span>
              <span>{this.state.testTaking}</span>
            </p>
            <p
              className="room-code"
              aria-label={`Room Code: ${this.props.userStore.room}`}
            >
              <span>Room Code:</span>
              <span>{this.props.userStore.room}</span>
            </p>
            {this.state.delivery_type.toLowerCase() === 'remote' && (
              <p
                className="launch-tz"
                aria-label={`Launch Location Timezone: ${this.state.launch_tz}`}
              >
                <span>Location Timezone:</span>
                <span>{this.state.launch_tz}</span>
              </p>
            )}
          </div>
        </div>
        <div className="buttons-container">
          <ButtonSecondary
            buttonText="No, this is incorrect"
            onClick={this.openModal}
          />
          <ButtonPrimary
            buttonText="Yes, this information is correct"
            onClick={this.continue}
          />
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          closeModal={this.closeModal}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title="Incorrect Information"
              description="Please inform the room proctor if your personal information or test details are incorrect."
              buttonText="Go to login"
              padding="0 75px"
              onClick={this.returnToLogin}
              closeModal={this.closeModal}
              role="none"
              onKeyUp={event =>
                this.modalNavigation(event, [
                  'button-primary-modal',
                  'close-modal',
                ])
              }
            />
          }
        />
        <Modal
          isOpen={this.state.browserModalIsOpen}
          closeModal={this.closeBridgeModal}
          className={'modal-content two-buttons'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupTwoButtons
              title="Open PSI Secure Browser"
              description={
                this.state.browserIsDownloading
                  ? 'The browser is currently downloading...'
                  : this.state.browserIsLaunching
                    ? 'If the PSI Secure Browser does not launch, please download, install, and try again.'
                    : 'Click Download for the latest PSI Secure Browser version. If the latest version is currently installed on this machine then choose Launch.'
              }
              button1Text="Download Browser"
              button2Text="Launch Browser"
              padding="0 75px"
              onClickBtn1={this.downloadBrowser}
              onClickBtn2={this.retryBrowser}
              onKeyUp={event =>
                this.modalNavigation(event, [
                  'button-primary-modal',
                  'button-secondary-modal',
                ])
              }
            />
          }
        />
      </main>
    ) : (
      <div>
        <div
          className="spinner-container"
          role="alert"
          aria-label="Please wait, the page is getting loaded."
        >
          <FadeLoader
            css={override}
            size={'350px'}
            sizeUnit="px"
            color="#042E60"
            loading={this.state.loading}
            height={30}
            width={7}
            margin={20}
          />
        </div>
        <Modal
          isOpen={this.state.hasError}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title="Error"
              description="Something went wrong. Please try again"
              buttonText="Go To Sign In"
              padding="0 75px"
              onClick={this.closeErrorModal}
            />
          }
        />

        <Modal
          isOpen={this.state.hasInvalidParams}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title="Invalid information"
              description="Invalid user information. Please sign in again."
              buttonText="Go To Sign In"
              padding="0 75px"
              onClick={this.closeInvalidModal}
            />
          }
        />
        <Modal
          isOpen={this.state.hasPSIError}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title="Operating system not supported"
              description="The PSI Secure Browser is currently only supported on Windows and MacOS. Please attempt to relaunch via one of the supported operating systems."
              buttonText="Go To Sign In"
              padding="0 75px"
              onClick={this.closePSIErrorModal}
            />
          }
        />
        <Modal
          isOpen={this.state.hasPSIUrlError}
          className={'modal-content one-button'}
          ariaProps={{
            modal: true,
          }}
          child={
            <PopupOneButton
              title="Invalid Browser URL"
              description="There is a missing or invalid acceptance token for your account."
              buttonText="Go To Sign In"
              padding="0 75px"
              onClick={this.closePSIUrlErrorModal}
            />
          }
        />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserConfirmation);
